// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"e4c4f7bb","703":"d13216cb","787":"4c15399f"}[chunkId] + ".chunk.js";
};